module.exports = __webpack_public_path__ + "static/popup-a909b775589c42a1a34e2bb380eca17a.png";